module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"login":"Log In","logout":"Log Out","fewer":"weniger","more":"mehr","profile":"Mein Profil","portfolio":"Portfolio","showroom":"Showroom"}}')
  delete Component.options._Ctor
}
